export default "__VITE_ASSET__DSWd5oaw__"